'use client';

import React, { useEffect, useRef } from 'react';
import styles from './sso.module.scss';
import { Button, Icon, validIcons, ButtonSize, ButtonType, Loader } from '@brahma/components';
import useLocale from '$hooks/use-locale';
import { COMMON } from '$locale/constants';
import { SubHeader } from '@brahma/components';
import { AnalyticsManager, useFetch, useLoadingRouter } from '@brahma/hooks';
import { interpolateString } from '@brahma/utils';
import { API_URLS } from '$constants/apis';
import { useSearchParams, useParams } from 'next/navigation';
import type { IBFFResponse, User } from '@dfg/brahma-types';
import { SEARCH_PARAMS_KEYS } from '$constants';
import useGlobalContext from '$hooks/use-global-context';
import { ContextAction } from '$context/global-context/types';
import { getRedirectUrl } from '$modules/onboarding/helpers';
const SsoLogin = () => {
  const {
    t
  } = useLocale(COMMON);
  const {
    routerPush,
    loading: pageLoading
  } = useLoadingRouter();
  const searchParams = useSearchParams();
  const prevCode = useRef('');
  const code = searchParams.get(SEARCH_PARAMS_KEYS.ssoLoginCode);
  const params = useParams();
  const globalContext = useGlobalContext();
  const redirectUrl = typeof location !== 'undefined' ? location.toString().replace(location.search, '') : '';
  const {
    data: loginUrlResponse,
    loading: loadingGetUrl,
    fetch: loginUrlFetch
  } = useFetch<IBFFResponse<string>>({
    url: interpolateString(API_URLS.getSsoLoginUrl, {
      redirectUrl: redirectUrl
    })
  }, false);
  const {
    data: ssoLoginResponse,
    fetch: ssoLoginFetch,
    loading: loadingSSo,
    error: ssoLoginError
  } = useFetch<IBFFResponse<User>>({
    url: interpolateString(API_URLS.ssoLogin, {
      code: code ?? '',
      redirectUrl: redirectUrl
    })
  }, false);
  useEffect(() => {
    if (code && prevCode.current !== code) {
      ssoLoginFetch();
      prevCode.current = code;
    }
    if (!code) {
      loginUrlFetch();
    }
  }, [code]);
  useEffect(() => {
    if (ssoLoginError?.error?.httpStatusCode) {
      if (ssoLoginError.error.httpStatusCode !== 401) {
        // in case of not aunthorized error, get redirect URL again
        loginUrlFetch();
      }
    }
  }, [ssoLoginError]);
  useEffect(() => {
    if (ssoLoginResponse?.code === 200) {
      globalContext.dispatch({
        type: ContextAction.setUser,
        payload: {
          ...ssoLoginResponse?.data,
          userGroups: ssoLoginResponse?.data?.userGroups ?? []
        }
      });

      // updating the user data  click stream after user has been successfully logged in.
      ssoLoginResponse.data && AnalyticsManager.getInstance().updateUserData(ssoLoginResponse.data);
      let path = `/${params.lang}/${getRedirectUrl(ssoLoginResponse.data)}`;
      routerPush(path);
    }
  }, [ssoLoginResponse]);
  const onSigninClicked = () => {
    if (loginUrlResponse?.data) routerPush(loginUrlResponse?.data);
  };
  return <div className={styles.parentContainer} data-sentry-component="SsoLogin" data-sentry-source-file="index.tsx">
      <Loader show={loadingSSo || loadingGetUrl || pageLoading} data-sentry-element="Loader" data-sentry-source-file="index.tsx" />
      <SubHeader iconName={validIcons.checkMarkShadow} title={t('ssoLogin.welcomeMessage')} description={t('ssoLogin.continueMessage')} iconClassName={styles.iconSubheader} iconWidth="144" background="gridDotMdDesktop" baseUrl={process.env.NEXT_PUBLIC_STATIC_URL ?? ''} data-sentry-element="SubHeader" data-sentry-source-file="index.tsx" />
      <Button text={t('ssoLogin.signIn')} variant={ButtonType.Secondary} size={ButtonSize.Large} startIcon={<Icon iconName={validIcons.google} />} className={styles.buttonBox} onClick={onSigninClicked} stopThrottle={true} data-sentry-element="Button" data-sentry-source-file="index.tsx" />
    </div>;
};
export default SsoLogin;